import React, { useEffect, useState, useRef } from "react";
import config from "../../config";
import { triggerNotification } from "../../component/message/Msg";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import Breadcrumb from "../../component/breadcrumb/Breadcrumb";
import Spinner from "../../component/loadingbar/Spinner";
import TableViewer from "../../component/tableViewer/TableViewer";

const LoginTracks = () => {
  const { token, user_type } = config;
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const [logintracks, setlogintracks] = useState([]);

  //  ------For TableViewer ------
  const logintracksRef = useRef([]);
  logintracksRef.current = logintracks;
  const [rowData, setRowData] = useState([]);
  //  ------For TableViewer ------
  //----------------------------------------------- select / view logintracks table  -------------------------------------------------R
  // Fetch all logintracks
  const fetchlogintracks = async () => {
    setLoading(true);
    try {
      await fetch(`${config.host_url}/pages/login-tracks`, {
        method: "GET",
        headers: {
          token: token,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.status === 200) {
            setlogintracks(data.data);
            console.log("ddddddddddddddd",data.data);
            
            //  ------For TableViewer ------
            const logintracksData = data.data.map((pkg) => ({
              user_name: pkg.user_name,  
              IP: pkg.ip,
              device_name: pkg.devicename,
             // icon: pkg.pkg_display_icon,
              OtherDetails: pkg.otherdetails,
              location: pkg.location,
              datetime: new Date(pkg.datetime).toLocaleString(),
              idNumber: pkg.userid,
            }));
            setRowData(logintracksData);
            //  ------For TableViewer ------
            // console.log(data.data);
          } else if (data.status === 401) {
            // Invalid token
            triggerNotification("error", "Unauthenticated user");
          } else {
            // Handle other errors
            triggerNotification(
              "error",
              "Internal server error, Please try after some time!!"
            );
          }
        });
    } catch (error) {
      triggerNotification("error", "Error fetching logintracks.");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchlogintracks();
  }, [token]);

  // ------------------------------------------------- View  logintrack ---------------------------------------------------- U
   // Function to handle row clicks
   const rowClickHandler = (row) => {
    const id = row.data.idNumber; // Assuming the id is stored in idNumber field
    navigate(`/viewstudent/${window.btoa(encodeURIComponent(id))}`);
  };


  // ------------------------------------------------- Edit / Update logintrack ---------------------------------------------------- U
  const btnEditHandle = (id) => {
    const encodedId = window.btoa(encodeURIComponent(id));
    navigate(`/addlogintrack/${encodedId}`);
  };

  // ---------------------------------------------------- Delete logintrack ---------------------------------------------------------D
  // Show a confirmation dialog
  const btnDeleteHandle = (deleteId, i) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You are about to delete logintrack. Are you sure you want to proceed?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        handleDeletelogintrack(deleteId, i);
      }
    });
  };

  //If confirm then delete logintrack
  const handleDeletelogintrack = async (deleteId, i) => {
    try {
      await fetch(`${config.host_url}logintracks/${deleteId}`, {
        method: "DELETE",
        headers: {
          token: token,
        },
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (data) {
          if (data.status === 200) {
            triggerNotification("success", "logintrack deleted successfully");

            //  ------For TableViewer ------
            const updatedlogintrack = [...logintracksRef.current];
            updatedlogintrack.splice(i, 1);
            setlogintracks(updatedlogintrack);
            const logintracksData = updatedlogintrack.map((pkg) => ({
              logintrack_name: pkg.pkg_name,
              icon: pkg.pkg_display_icon,
              priority: pkg.pkg_priority,
              type: pkg.pkg_type,
              catagory: pkg.pkg_catagory_name,
              idNumber: pkg.pacakge_id,
            }));
            setRowData(logintracksData);
            //  ------For TableViewer ------
          } else if (data.status === 404) {
            console.error("logintrack IDs not found");
            triggerNotification("error", "logintrack IDs not found");
          } else if (data.status === 401) {
            // Invalid Token
            console.error("Invalid token");
            triggerNotification("error", "Unauthenticated User");
          } else {
            // Internal Server Error or other HTTP errors
            console.error("Internal server error");
            triggerNotification(
              "error",
              "Internal server error, Please try after some time!"
            );
          }
        });
    } catch (error) {
      console.error("Error deleting logintrack:", error);
      triggerNotification("error", "Error deleting logintrack");
    }
  };

  //  ------For TableViewer ------
  const colDefs = [
    {
      headerName: "#",
      width: 50,
      valueFormatter: (params) => {
        return `${parseInt(params.node.id) + 1}`;
      },
    },
    {
      headerName: "User Name",
      field: "user_name",
      width: 300,
      cellRenderer: (params) => (
        <div className=" flex py-1 ">
          {/* <img
            src={params.data.icon}
            alt="Teacher_Image"
            className="rounded h-11 w-11  mr-4"
          /> */}
          <p className="p-0 m-0">{params.data.user_name}</p>
        </div>
      ),
    },
    { field: "IP", filter: true },
    {
      headerName: "Device Name",
      field: "device_name",
      width: 300,
      cellRenderer: (params) => (
        <div className=" flex py-1 ">
          {/* <img
            src={params.data.icon}
            alt="Teacher_Image"
            className="rounded h-11 w-11  mr-4"
          /> */}
          <p className="p-0 m-0">{params.data.device_name}</p>
        </div>
      ),
    },
    { headerName: "Other Details", field: "OtherDetails", filter: true },
    { field: "location", filter: true },
    { headerName: "Date Time", field: "datetime", filter: true },
  ];
  //  ------For TableViewer ------
  return (
    <>
      <Breadcrumb txt="Login Tracks" subpath={[""]} />
      <div className="col-xxl">
        <div className="card mb-4">
          <div className="card-header d-flex align-items-center flex justify-between">
            <h5 className="mb-0">Login Tracks</h5>
            {/* <button
              type="button"
              className="btn btn-primary"
              onClick={() => {
                navigate("/addlogintrack");
              }}
            >
              Add logintrack
            </button> */}
          </div>
          {loading ? (
            <Spinner />
          ) : (
            <div className="px-3 pb-3  table-responsive">
              <TableViewer
                rowData={rowData}
                colDefs={colDefs}
                //onEdit={btnEditHandle}
               // onDelete={btnDeleteHandle}
                //onView={btnShowHandle}
                onRowClicked={rowClickHandler}
                // haveImage
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default LoginTracks;
